/* @flow */

import { rem } from 'polished';

import { baseFontSize } from '@braindate/ui/lib/token/typography';

export default {
  'ol, ul': {
    margin: [rem(20, baseFontSize), 0],
    padding: [0, 0, 0, rem(36, baseFontSize)],

    '& ol, & ul, & li > p': {
      marginTop: 0,
    },
  },
};
